import { useRecoilValue } from "recoil";
import { isLoggedIn } from "api/coachAuth";
import { userAtom } from "../recoil/userAtom";

/**
 * Home 에서는 사용 금지
 * user context 업데이트 전임.
 */
export default function useRole() {
  const user = useRecoilValue(userAtom);

  const isCoach =
    isLoggedIn(user) && user?.role !== undefined && user?.role !== "patient";

  const isPatient =
    isLoggedIn(user) && user?.role !== undefined && user?.role === "patient";

  const isAdmin =
    isLoggedIn(user) && user?.role !== undefined && user?.role === "admin";

  const isEarlyAccessCoach =
    isLoggedIn(user) &&
    user?.role !== undefined &&
    user?.role !== "patient" &&
    user?.isEarlyAccess;

  return {
    isPatient,
    isCoach,
    isAdmin,
    isEarlyAccessCoach,
  };
}
